<div class="header-actions">
  <app-paste-query-from-saved (pasted)="paste($event)" (removed)="remove($event)" [type]="type">
  </app-paste-query-from-saved>
  <app-append-query-popover (appended)="append($event, builder.value)">
  </app-append-query-popover>
</div>

<mat-dialog-content>
  <app-query-builder #builder [fields]="fieldMap" [ruleSet]="ruleSet">
  </app-query-builder>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button color="warn" mat-dialog-close mat-raised-button>{{ 'QUERY_BUILDER.close' | translate }}</button>
  <button color="primary" [mat-dialog-close]="builder.value" mat-raised-button>{{ 'QUERY_BUILDER.apply' | translate }}</button>
</mat-dialog-actions>
